enum AppStoreOptions {
    AppStore = 'AppStore',
    GooglePlay = 'GooglePlay',
}

export default AppStoreOptions
